import { api } from '../services/api';
import { TipoNotificacao } from '../constants/notificationTypes';
import type { DadosJsonDeNotificacao } from '../constants/notificationHandlers';

export type { TipoNotificacao, DadosJsonDeNotificacao };

// A FORMA da notificação mora no registry (`constants/notificationHandlers`),
// composta a partir do que cada domínio declara no `notificacoes.ts` dele.
// Este arquivo é o TRANSPORTE: as 4 chamadas ao `/api/v1/notificacoes/`.
//
// Re-exportado daqui porque é por este módulo que o provider e os testes já
// consomem — e `export type` é apagado na compilação, então não cria import em
// runtime.
export type {
  DadosWsDeNotificacao,
  EnvelopeDeNotificacao,
  IWebSocketMessage,
} from '../constants/notificationHandlers';

export interface INotificacao {
  id: number;
  usuario_id: number;
  tipo: TipoNotificacao;
  titulo: string;
  mensagem: string;
  dados_json: DadosJsonDeNotificacao | null;
  dt_leitura: string | null;
  referencia_tipo: string | null;
  referencia_id: number | null;
  dt_criacao: string;
  dt_atualizacao: string;
}

interface INotificacoesResponse {
  status_code: number;
  data: INotificacao[];
}

interface IUnreadCountResponse {
  status_code: number;
  data: { total: number };
}

interface IMarcarLidaResponse {
  status_code: number;
  data: INotificacao;
}

interface IMarcarTodasLidasResponse {
  status_code: number;
  data: { total_marcadas: number };
  message: string;
}

export interface INotificacoesParams {
  apenas_nao_lidas?: boolean;
  skip?: number;
  limit?: number;
}

export const useNotificacoes = () => {
  const getNotificacoes = async (params?: INotificacoesParams): Promise<INotificacoesResponse> => {
    const res = await api.get<INotificacoesResponse>('/api/v1/notificacoes/', {
      params,
    });
    return res.data;
  };

  const getUnreadCount = async (): Promise<IUnreadCountResponse> => {
    const res = await api.get<IUnreadCountResponse>('/api/v1/notificacoes/nao-lidas/count/');
    return res.data;
  };

  const marcarComoLida = async (notificacaoId: number): Promise<IMarcarLidaResponse> => {
    const res = await api.put<IMarcarLidaResponse>(`/api/v1/notificacoes/${notificacaoId}/lida/`);
    return res.data;
  };

  const marcarTodasComoLidas = async (): Promise<IMarcarTodasLidasResponse> => {
    const res = await api.put<IMarcarTodasLidasResponse>(
      '/api/v1/notificacoes/marcar-todas-lidas/',
    );
    return res.data;
  };

  return {
    getNotificacoes,
    getUnreadCount,
    marcarComoLida,
    marcarTodasComoLidas,
  };
};
